import { request } from "./request";

// 区分国内国际
export function getCooperate(isDomestic, startIndex, length) {
  return request({
    url: '/cooperate/queryCooperate',
    params: { isDomestic, startIndex, length }
  })
}


// 不区分国内国际
export function selectCooperate(startIndex, length) {
  return request({
    url: '/cooperate/selectCooperate',
    params: { startIndex, length }
  })
}


export function totalCooperate(isDomestic) {
  return request({
    url: '/cooperate/totalCooperate',
    params: { isDomestic }
  })
}


export function insertCooperate(title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
                               note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, isDomestic, CooperateObj, CooperateObjEn,
                                createdUser, imgLength) {
  return request({
    url: '/cooperate/insert',
    method: 'post',
    params: {
      title, titleEn, word1, word1En, note1, note1En, word2, word2En, note2, note2En, word3, word3En, note3, note3En, word4, word4En,
      note4, note4En, word5, word5En, note5, note5En, word6, word6En, note6, note6En, isDomestic, CooperateObj, CooperateObjEn,  createdUser, imgLength
    }
  })
}

export function delCooperate(id) {
  return request({
    url: '/cooperate/delCooperate',
    params:{ id }
  })
}

